/**
 * Message FR pour les menus
 */

module.exports = {

    // Menu latéral
    side: {

        home: {
            label: 'Dashboard',
            altLabel: 'Return to dashboard.'
        },

        superAdmin: {
            label: 'Application settings (Super Admin)',
            altLabel: 'View Super Admin application settings.'
        },

        me: {
            account: {
                label: 'My account',
                altLabel: 'View your account settings.'
            },
            requestedHolidays: {
                internal: {
                    label: 'Vacation requests',
                    altLabel: 'View your vacation requests.'
                },
                external: {
                    label: 'Absence request',
                    altLabel: 'View your absence requests'
                }
            },
            task: {
                managing: {
                    label: 'Tasks',
                    altLabel: 'View the tasks assigned to your agents'
                },
                running: {
                    label: 'Tasks',
                    altLabel: 'View the tasks assigned to you.'
                },
                list: {
                    label: 'Publications',
                    altLabel: 'View the list of publications.'
                },
                write: {
                    label: 'Add a post',
                    altLabel: 'Start writing a task.'
                }
            },

        },

        admin: {
            credits: {
                label: 'Credit administration',
                altLabel: 'Manage rates for tasks, credits and subscriptions.'
            },
            videos: {
                label: 'Videos administration',
                altLabel: 'Manage videos proposed for publication.',
                tutorial: {
                    label: 'Videos tutorials',
                    altLabel: 'Manage the videos tutorials.',
                }
            },
            publicationIdeas: {
                label: 'Administration of publication ideas',
                altLabel: 'Manage publication ideas.'
            },
            horseChestnut: {
                label: 'Evergreen',
                altLabel: 'Manage evergreen events'
            },
            promotionCodes: {
                label: 'Promotion codes',
                altLabel: 'Manage promotion codes'
            },
            bills: {
                label: 'Invoices',
                altLabel: 'View customer invoices.'
            }
        },

        // Label spécifique pour les clients
        customer: {
            communityManager: {
                label: 'Community Manager',
            },
            editorialLine: {
                label: 'Editorial line'
            },
            roles: {
                label: 'Permissions and roles',
                altLabel: 'Manage your users\' roles.'
            },
            contacts: {
                label: 'Users',
                altLabel: 'Manage your users\' accounts.'
            },
            statistics: {
                label: 'Statistics',
                altLabel: 'Consult your social network statistics.'
            },

            tasks: {
                submenu: {
                    label: 'Inspirations & Posts'
                },
                list: {
                    label: 'List of posts',
                },
                requestValidation: {
                    label: 'Posts validation'
                },
                add: {
                    label: 'Add posts'
                },
                statistics: {
                    label: 'Statistics'
                }
            },
            publicationsComments: {
                list: {
                    label: 'Comments',
                }
            },
            settings: {
                submenu: {
                    label: 'Settings'
                },
                editorialLine: {
                    label: 'Editorial line',
                },
                writingStyles: {
                    label: 'Writing Style'
                },
                visualIdentity: {
                    label: 'Visual identity'
                },
                postsSettings: {
                    label: 'Customizing posts'
                },
                graphicalTemplates: {
                    label: 'Graphic models'
                },
                socialNetworks: {
                    label: 'My social networks'
                }
            },

            administration: {
                submenu: {
                    label: 'Administration'
                },
                roles: {
                    label: 'Roles',
                },
                contacts: {
                    label: 'Contacts'
                },
                notifications: {
                    label: 'Notifications'
                },
                repositoryFiles: {
                    label: 'My file directory'
                }
            }
        },

        creditsAndSubscription: {
            submenu: {
                label: 'Credits and Subscriptions'
            },
        },

        administration: {
            submenu: {
                label: 'Administration'
            },
        },

        unsubscribeMessages: {
            label: 'Unsubscribe messages',
            altLabel: 'Manage messages and unsubscribe statistics.'
        },

        permissionRole: {
            submenu: {
                label: 'Permissions and Roles'
            },
            permissions: {
                label: 'Permission management',
                altLabel: 'Manage the permissions list.'
            },
            roles: {
                label: 'Roles management',
                altLabel: 'Manage your users\' role list.'
            },
        },
        application: {
            label: 'Customize the application',
            altLabel: 'Manage the application\'s Terms and Conditions and Privacy Policy'
        },
        mailsConfiguration: {
            label: 'E-mail Configuration',
            altLabel: 'Manage internal email configuration.'
        },

        users: {
            submenu: {
                label: 'Users'
            },
            internalAgent: {
                label: 'Internal agent management',
                altLabel: 'Manage the list of internal agents.'
            },
            externalAgent: {
                label: 'External agent management',
                altLabel: 'Manage the list of external agents.'
            },
            teamManager: {
                label: 'Lead management',
                altLabel: 'List of managers.'
            },
            productManager: {
                label: 'Product management',
                altLabel: 'List of product managers.'
            },
            agencyManager: {
                label: 'Agency Manager management',
                altLabel: 'View the list of agency managers'
            },
            customer: {
                label: 'Customer management',
                altLabel: 'Manage a customer list'
            },

            requestedHolidays: {
                label: 'Holiday request',
                altLabel: 'Consult and respond to vacation requests'
            },

            agencyCustomer: {
                item: {
                    altLabel: 'Consult the post list for the customer { customer }.',
                    profileImage: {
                        altLabel: 'Profile image of { customer }.'
                    }
                }
            }

        },

        contacts: {
            label: 'Contact management',
            altLabel: 'Manage the list of contact accounts attached to your own account.'
        },

        activitySectors: {
            label: 'Business sectors',
            altLabel: 'Manage the list of business sectors and their professions.'
        },

        coachingOffers: {
            label: 'Coaching offers',
            altLabel: 'Manage coaching offers'
        },

        logout: {
            label: 'Log out',
            altLabel: 'Log out from the platform'
        }
    },

    // Menu du header
    header: {
        account: {
            userAccount: {
                label: 'My account',
                altLabel: 'View your account information.'
            },
            subscription: {
                label: 'My plan',
                altLabel: 'View the details of your subscription.'
            },
            bills: {
                label: 'My bills',
                altLabel: 'Consult your bills'
            },
            logout: {
                label: 'Log out',
                altLabel: 'Log out from the application'
            },

            agency: {
                users: {
                    label: 'Users management',
                    altLabel: 'View the list of users of the agency.'
                }
            }
        },
        helpButton: {
            label: 'Help'
        },
        trialPeriod: {
            remainingTime: 'remaining before the end of your trial period | remaining before the end of your trial period | remaining before the end of your trial period'
        }
    },

    // Menu déroulant de sélection des profils des réseaux sociaux
    socialNetworks: {
        profiles: {
            dropdown: {
                label: 'Choosing an account'
            }
        }
    },

    agency: {
        customer: {
            // Menu de raccourcis pour la gestion d'un client d'une agence
            shortcutMenu: {
                tasksList: {
                    altLabel: 'Manage the posts for { customer }.'
                },
                comments: {
                    altLabel: 'Manage the comments for { customer }.'
                },
                statistics: {
                    altLabel: 'View the statistics for { customer }.'
                },
                postsSettings: {
                    altLabel: 'Manage the post customization for { customer }.'
                },
                visualIdentity: {
                    altLabel: 'Manage the visual identity for { customer }.'
                },
                writingStyles: {
                    altLabel: 'View the writing style for { customer }.'
                },
                graphicalLineTemplates: {
                    altLabel: 'Manage the graphic models for { customer }.'
                }
            }
        }
    }
};
